import { ReactElement, useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { Large } from '../../typography'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../redux/store'
import { convertHMS } from '../../helpers/formatTime'

export const TimerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 20px;
  height: 30px;
`

const Timer = (): ReactElement => {
  const { duration = 0 } = useSelector(
    (state: RootState) => ({
      duration: state.test?.testPaperDetails?.testPaper?.duration
    }),
    shallowEqual
  )
  const [counter, setCounter] = useState(duration * 60)

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000)
  }, [counter])

  return (
    <TimerWrapper>
      <FontAwesomeIcon icon={['far', 'clock']} size="lg" />
      <Large>{convertHMS(counter)}</Large>
    </TimerWrapper>
  )
}

export default Timer
